import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_PAYU_FAILED,
  GET_PAYU_REQUESTED,
  GET_PAYU_RESPONSE_FAILED,
  GET_PAYU_RESPONSE_REQUESTED,
  GET_PAYU_RESPONSE_SUCCESS,
  GET_PAYU_SUCCESS,
} from "resources/actionTypes";
import { payUApi, payuResponseApi } from "services/PayuService";

function* fetchPayu(action) {
  const payload = action.payload || {};
  const userPayu = yield call(payUApi, payload.getPayuDetail);
  if (userPayu?.success) {
    yield put({ type: GET_PAYU_SUCCESS, userPayu: userPayu });
    toast.success(userPayu?.message)
    window.location.replace(userPayu?.data)
  }
  else{
    yield put({type: GET_PAYU_FAILED, message: userPayu?.message});
      toast.error(userPayu?.message || "userPayu failed");
  }
}
export function* payuSaga(){
  yield takeEvery(GET_PAYU_REQUESTED, fetchPayu);
}

function* fetchPayuResponse(action) {
  const userPayuResponse = yield call(payuResponseApi);
  if (userPayuResponse?.success) {
    yield put({ type: GET_PAYU_RESPONSE_SUCCESS, userPayuResponse: userPayuResponse });
    toast.success(userPayuResponse?.message)
  }
  else{
    yield put({type: GET_PAYU_RESPONSE_FAILED, message: userPayuResponse?.message});
      toast.error(userPayuResponse?.message || "userPayuResponse failed");
  }
}
export function* payuResponseSaga(){
  yield takeEvery(GET_PAYU_RESPONSE_REQUESTED, fetchPayuResponse);
}
